import { ActionType, createAsyncAction } from "typesafe-actions";

import Folder from "@mapmycustomers/shared/types/entity/Folder";
import Resource from "@mapmycustomers/shared/types/entity/Resource";
import ViewState from "@mapmycustomers/shared/types/viewModel/ViewState";

export const fetchResources = createAsyncAction(
  "@resources/fetchResources/request",
  "@resources/fetchResources/success",
  "@resources/fetchResources/failure"
)<
  {
    failureCallback?: () => void;
    successCallback: (payload: { resources: Resource[]; total: number }) => void;
    viewState: Partial<ViewState>;
  },
  void,
  void
>();

export const fetchPinnedResources = createAsyncAction(
  "@resources/fetchPinnedResources/request",
  "@resources/fetchPinnedResources/success",
  "@resources/fetchPinnedResources/failure"
)<
  {
    failureCallback?: () => void;
    successCallback: (resources: Resource[]) => void;
  },
  void,
  void
>();

export const fetchFolders = createAsyncAction(
  "@resources/fetchFolders/request",
  "@resources/fetchFolders/success",
  "@resources/fetchFolders/failure"
)<{ callback: (folders: Folder[]) => void; query?: string }, void, void>();

export type Actions = ActionType<
  typeof fetchFolders | typeof fetchPinnedResources | typeof fetchResources
>;
